import { EyeOutlined, StarOutlined } from "@ant-design/icons";
import { Layout, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";

import BaseHeader from "@/components/Header/BaseHeader";
import InterventionsTable from "@/components/ListTable/InterventionsTable";
import ProjectsTable from "@/components/ListTable/ProjectsTable";
import { STORAGE_KEYS } from "@/constants/StorageKeys";
import { TAB_KEYS, TAB_PARAM_KEYS } from "@/constants/TabKeys";
import { useGetCurrentUser } from "@/entities/current-user";
import {
  INTERVENTIONS_FILTERS,
  INTERVENTIONS_INCLUDES,
} from "@/entities/interventions";
import { PROJECTS_FILTERS } from "@/entities/projects";
import { ListProvider } from "@/modules/list";
import { MODEL_KEY } from "@/modules/model";
import ModelIcon from "@/modules/model-icon";
import OrganizationTreeCard from "@/modules/organization/organization-tree-card";
import { ContextTabs } from "@/ui/context-tabs";

import Favorites from "./Favorites";
import RecentlyViewed from "./RecentlyViewed";

import "./UserItems.style.less";

const { Content } = Layout;

const UserItems = () => {
  const { t } = useTranslation();
  const { currentUser } = useGetCurrentUser();
  const location = useLocation();

  const defaultTab =
    location?.search?.[TAB_PARAM_KEYS.CONTEXT_TAB_KEY] ?? "interventions";

  const InterventionIncludes = [
    INTERVENTIONS_INCLUDES.USERS,
    INTERVENTIONS_INCLUDES.TEMPLATE,
  ];

  const tabs = [
    {
      key: TAB_KEYS.MY_SPACE_INTERVENTIONS,
      label: t("global:interventionPlural"),
      icon: <ModelIcon model={MODEL_KEY.INTERVENTION} />,
      children: (
        <ListProvider
          model="interventions"
          storageKey={STORAGE_KEYS.MY_SPACE_INTERVENTIONS}
          contextTabValue={TAB_KEYS.MY_SPACE_INTERVENTIONS}
          hiddenFilters={{ [INTERVENTIONS_FILTERS.USERS_ID]: currentUser?.id }}
          includes={InterventionIncludes}
        >
          <InterventionsTable showLocationColumn showAssetColumn />
        </ListProvider>
      ),
    },
    {
      key: TAB_KEYS.MY_SPACE_PROJECTS,
      icon: <ModelIcon model={MODEL_KEY.PROJECT} />,
      label: t("global:projectPlural"),
      children: (
        <ListProvider
          model="projects"
          storageKey={STORAGE_KEYS.MY_SPACE_PROJECTS}
          contextTabValue={TAB_KEYS.MY_SPACE_PROJECTS}
          hiddenFilters={{ [PROJECTS_FILTERS.USERS_ID]: currentUser?.id }}
        >
          <ProjectsTable showLocationColumn showOrganizationColumn />
        </ListProvider>
      ),
    },
    {
      key: TAB_KEYS.MY_SPACE_RECENTS,
      icon: <EyeOutlined />,
      label: t("dashboard:recents"),
      children: <RecentlyViewed />,
    },
    {
      key: TAB_KEYS.MY_SPACE_FAVORITES,
      icon: <StarOutlined />,
      label: t("dashboard:favorites"),
      children: <Favorites />,
    },
  ];

  return (
    <>
      <BaseHeader title={t("navigation:mySpace")} />
      <Content className="user-items">
        <div className="organization-column">
          <div className="organization-column-title">
            <ModelIcon model="organization" />
            <Typography.Title level={3}>
              {t("global:organizationPlural")}
            </Typography.Title>
          </div>
          <OrganizationTreeCard saveStateKey="my-space-organization-tree" />
        </div>
        <div>
          <ContextTabs defaultActiveKey={defaultTab} items={tabs} />
        </div>
      </Content>
    </>
  );
};

export default UserItems;
